import { DrawerHeader } from "../../../../components/drawer/drawer-header";
import { Icon } from "../../../../components/icon/icon";
import {
  FormHeaderTextarea,
  FormFieldName,
  FormSelect
} from "../../../../components/form/form";
import { memo } from "react";
import { useRuleEdit } from "./rule-edit.hook";
import { Drawer } from "../../../../components/drawer/drawer";
import { Form } from "antd";
import { useTranslation } from "react-i18next";
import DropdownFilters from "../../../../components/dropdown-filters/dropdown-filters";

const RuleCardInside = memo(
  ({
    ruleFilters,
    rule,
    close,
    editMode,
    createRule,
    updateRule,
    cancelEditing,
    deleteRule,
    toEditMode,
    onlyView,
  }) => {
    const { t } = useTranslation();
    const control = useRuleEdit({
      rule,
      createRule,
      updateRule,
      cancelEditing,
      close,
    });

    const conditions = [
      {
        name: "Block content matching criteria below",
        id: "exclude"
      },
      {
        name: "Only show content matching criteria below",
        id: "only",
      }
    ]

    return (
      <>
        <DrawerHeader
          title={<p className="life-fact-title">{t("rule_management.title")}</p>}
          isEditing={editMode}
          onEdit={onlyView ? undefined : toEditMode}
          onClose={close}
          onSave={control.save}
          onCancel={control.cancel}
          menu={
            onlyView
              ? undefined
              : {
                  items: [
                    {
                      label: "Delete",
                      icon: (
                        <Icon
                          name={"delete"}
                          style={{ marginRight: 8, marginLeft: -4 }}
                        />
                      ),
                      onClick: deleteRule,
                    },
                  ]
                }
          }

        />
        <div style={{ paddingBottom: 24 }} />
        <div style={{ paddingBottom: 24 }} >
          <FormHeaderTextarea
            readonly={!editMode}
            placeholder={"Title"}
            defaultValue={control.title.value}
            onChange={control.title.update}
            maxLength={100}
          />
        </div>
        <div className="textarea-edit-block">
          <Form.Item style={{ marginBottom: 0 }} name="subjectFilters">
            <div style={{ display: "flex", flexDirection: "column", width: "100%" }}>
              <FormFieldName text="Use filter to select subjects" />
              <DropdownFilters
                mode="controlled"
                filtersBy={ruleFilters.filtersBySubject}
                updateFilterValue={control.subjectFilters.update}
                filter={control.subjectFilters.value}
                readOnly={!editMode}
              />
            </div>
          </Form.Item>
          <div className="rule-count">
            {rule?.counts?.subjectMatches ?? 0} subject matches
          </div>
        </div>
        <div style={{ paddingBottom: 16 }} />
        <Form.Item style={{ marginBottom: 0 }} name="condition" className="rule-condition-field">
          <FormFieldName text="Content filtering type" />
          <FormSelect
            options={conditions.map((c) => ({
              value: c.id,
              label: c.name,
              key: c.id,
            }))}
            value={control.condition.value}
            onSelect={(value) => {
              control.condition.change?.(value)
            }}
            placeholder={editMode ? "Select condition..." : undefined}
            style={{ minWidth: 160 }}
            readonly={!editMode}
          />
        </Form.Item>
        <div style={{ paddingBottom: 16 }} />
        <div className="textarea-edit-block">
          <Form.Item style={{ marginBottom: 0 }} name="articleFilters">
            <div style={{ display: "flex", flexDirection: "column", width: "100%" }}>
              <FormFieldName text="Use filter to select articles" />
              <DropdownFilters
                mode="controlled"
                filtersBy={ruleFilters.filtersByPage}
                updateFilterValue={control.pageFilters.update}
                readOnly={!editMode}
                filter={control.pageFilters.value}
              />
            </div>
          </Form.Item>
          <div className="rule-count">
            {rule?.counts?.pageMatches ?? 0} articles matches
          </div>
        </div>
        <div style={{ paddingBottom: 16 }} />
        <div className="textarea-edit-block">
          <Form.Item style={{ marginBottom: 0 }} name="fitfactFilters">
            <div style={{ display: "flex", flexDirection: "column", width: "100%" }}>
              <FormFieldName text="Use filter to select FitFacts" />
              <DropdownFilters
                mode="controlled"
                filtersBy={ruleFilters.filtersByFact}
                updateFilterValue={control.factFilters.update}
                readOnly={!editMode}
                filter={control.factFilters.value}
              />
            </div>
          </Form.Item>
          <div className="rule-count">
            {rule?.counts?.factMatches ?? 0} FitFact matches
          </div>
        </div>
      </>
    );
  }
);

const RuleCard = ({
  rule,
  isOpen,
  close,
  editMode,
  createRule,
  updateRule,
  deleteRule,
  toEditMode,
  cancelEditing,
  onlyView,
  ruleFilters
}) => {
  return (
    <Drawer open={isOpen} size={800} closable={false} onClose={close}>
      <div style={{ paddingBottom: 48 }}>
        {isOpen && (
          <RuleCardInside
            ruleFilters={ruleFilters}
            rule={rule}
            createRule={createRule}
            close={close}
            cancelEditing={cancelEditing}
            updateRule={updateRule}
            deleteRule={deleteRule}
            toEditMode={toEditMode}
            editMode={editMode}
            onlyView={onlyView}
          />
        )}
      </div>
    </Drawer>
  );
};

export default RuleCard;
